import { type RouteRecordRaw } from "vue-router";
import { canAccess, haveOneAccess, permissionList } from "@/utilities/authorization";

const userRoutes: RouteRecordRaw[] = [
    {
        name: 'user-navigation',
        path: '/user/navigation',
        component: () => import('@/views/user/UserNavigation.vue'),
        beforeEnter: () => haveOneAccess([
            permissionList.READ_USER,
            permissionList.CREATE_USER
        ]) ? true : { name: 'dashboard' },
    },
    {
        name: 'user',
        path: '/user',
        component: () => import('@/views/user/UserIndex.vue'),
        beforeEnter: () => canAccess(permissionList.READ_USER) ? true : { name: 'user-navigation' },
    },
    {
        name: 'invite-user',
        path: '/user/invite',
        component: () => import('@/views/user/invitation/InviteUser.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_USER) ? true : { name: 'user-navigation' },
    },
    {
        name: 'invitation-detail',
        path: '/user/invitation/:id(\\d+)',
        component: () => import('@/views/user/invitation/InvitationDetail.vue'),
        beforeEnter: () => canAccess(permissionList.CREATE_USER) ? true : { name: 'user-navigation' },
    },
    {
        name: 'user-detail',
        path: '/user/:id(\\d+)',
        component: () => import('@/views/user/DetailUser.vue'),
        beforeEnter: () => canAccess(permissionList.READ_USER) ? true : { name: 'user-navigation' }
    },
    {
        name: 'user-update',
        path: '/user/update/:id(\\d+)',
        component: () => import('@/views/user/UpdateUser.vue'),
        beforeEnter: () => canAccess(permissionList.UPDATE_USER) ? true : { name: 'user-navigation' }
    },
]

export default userRoutes
